export const parseProfileSettings = (profile) => {
  if (!profile?.settings) return {};
  if (typeof profile.settings === 'object') return profile.settings;
  try {
    const parsed = JSON.parse(profile.settings);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_) {
    return {};
  }
};

export const getConfiguredAdvertiserIds = (profile) => {
  const source = parseProfileSettings(profile)?.ad_sets?.infillion || {};
  const raw = source.advertiser_ids ?? source.id ?? [];
  return [...new Set((Array.isArray(raw) ? raw : [raw]).map((value) => String(value ?? '').trim()).filter(Boolean))];
};

export const normalizeReportResponse = (payload) => ({
  range: payload?.range || {},
  selectedAdvertisers: Array.isArray(payload?.selectedAdvertisers) ? payload.selectedAdvertisers : [],
  summary: payload?.summary || { impressions: 0, clicks: 0, conversions: 0, spend: 0, ctr: 0 },
  daily: Array.isArray(payload?.daily) ? payload.daily : [],
  advertisers: Array.isArray(payload?.advertisers) ? payload.advertisers : [],
  campaigns: Array.isArray(payload?.campaigns) ? payload.campaigns : [],
  creatives: Array.isArray(payload?.creatives) ? payload.creatives : [],
  availableCampaigns: Array.isArray(payload?.availableCampaigns) ? payload.availableCampaigns : [],
  selectedCampaignIds: Array.isArray(payload?.selectedCampaignIds) ? payload.selectedCampaignIds : [],
  campaignFilterActive: payload?.campaignFilterActive === true,
  coverage: payload?.coverage || { status: 'empty', requestedDays: 0, coveredDays: 0, rowCount: 0 },
});

export const readApiError = (payload, status) => {
  const message = payload?.error?.message || payload?.message || payload?.error;
  return {
    code: payload?.error?.code || (status === 401 ? 'AUTHENTICATION_REQUIRED' : status === 403 ? 'CLIENT_SCOPE_FORBIDDEN' : 'INFILLION_REPORT_FAILED'),
    message: typeof message === 'string' && message.trim() ? message : 'Programmatic performance data could not be loaded.',
    status,
  };
};

export const formatInteger = (value) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(value || 0));
export const formatDecimal = (value) => new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value || 0));
export const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(Number(value || 0));
export const formatPercent = (value) => `${Number(value || 0).toFixed(2)}%`;

export const buildInfillionRequest = ({ cid, startDate, endDate, advertiserIds, selectedCampaignIds = null }) => ({
  cid: String(cid || '').trim(),
  startDate: String(startDate || '').slice(0, 10),
  endDate: String(endDate || '').slice(0, 10),
  advertiserIds: [...new Set((advertiserIds || []).map((value) => String(value).trim()).filter(Boolean))],
  campaignFilterActive: Array.isArray(selectedCampaignIds),
  campaignIds: Array.isArray(selectedCampaignIds)
    ? [...new Set(selectedCampaignIds.map((value) => String(value).trim()).filter(Boolean))]
    : [],
});
